module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO30DiferentesTiposDeGastosc.5f1407f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO30DiferentesTiposDeGastosc.mp4
// module id = 756
// module chunks = 1